import React, { useEffect } from "react";
import {
  Grid,
  Typography,
  Box,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Button,
  FormHelperText,
  DialogContent,
  TextField,
  Dialog,
} from "@material-ui/core";
import InputMask from "react-input-mask";
import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import styles from "../../../../styles/global-styles";
import { ProviderService } from "../../../../services/provider.service";
import { AccesoryService } from "../../../../services/accesory.service";
import NumberFormatCustom from "../../../stateless/NumberFormatCustom";
import { connect } from "react-redux";
import { actions } from "../../../../redux/actions/alert";
import SubcategorySelect from "../../../shared/selects/SubcategorySelect";
import ColorOptionForm from "../../../shared/selects/color-select/ColorOptionForm";
import ModalAddColor from "../../../shared/selects/color-select/ModalAddColor";
import { validateEmptyValuesInForm } from "../../../../_utils/utils";

const useStyles = makeStyles((theme) => ({
  form: {
    width: "auto", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  label: {
    marginBottom: "1.5vh",
  },
  box: {
    marginTop: "20px",
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: 2,
  },
  formControl: styles.globalFormControl,
  backgroundIcon: styles.backgroundIcon,
  addColorButton: styles.addColorButton,
  rightButton: styles.buttonRightHeader,
}));

const AccesoryForm = ({ detailAlert, addAlert, newAccesory }) => {
  const classes = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const [accesory, setNewAccesory] = React.useState({});
  const [providerArray, setProviderArray] = React.useState([]);
  const [hasError, setHasError] = React.useState(false);
  const [errorSubcategory, setErrorSubcategory] = React.useState(false);
  const [openModal, setOpenModal] = React.useState(false);
  const [timeGuarantee, setTimeGuarantee] = React.useState("");
  const [disabledButton, setDisabledButton] = React.useState(false);

  useEffect(() => {
    (async function () {
      try {
        const { data } = await ProviderService.getAllProvidersActive();
        setProviderArray(data);
      } catch (error) {
        addAlert({ showAlert: true });
        detailAlert({ severity: "error", message: error.msgs });
      }
    })();
  }, []);

  useEffect(() => {
    if (accesory.inDistribution !== undefined && !accesory.accesoryId) {
      setDisabledButton(true);
      (async () => {
        const validatedProduct = validateEmptyValuesInForm(accesory);
        try {
          const {
            data,
            data: { accesoryId, id },
          } = await AccesoryService.postAccesory(validatedProduct);
          console.log("product created", data);
          setNewAccesory({
            ...accesory,
            accesoryId,
            productId: id,
          });
        } catch (error) {
          const copyAccesory = { ...accesory };
          const { inDistribution, ...accesoryWithoutDistribution } =
            copyAccesory;
          setNewAccesory(accesoryWithoutDistribution);
          addAlert({ showAlert: true });
          detailAlert({ severity: "error", message: error.msgs });
        }
        setDisabledButton(false);
      })();
    }
    if (accesory.accesoryId && accesory.productId) {
      newAccesory(accesory, "accesory");
      setDisabledButton(false);
    }
  }, [accesory]);

  const handleSubcategorySelected = (key, value) => {
    setNewAccesory({ ...accesory, [key]: value });
    setErrorSubcategory(false);
  };

  const handleInputText = ({ target: { name, value } }) => {
    if (name === "providerId" && value) setHasError(false);
    if (name === "barCode" && value) {
      const codeBar = value.replaceAll(/-/gi, "");
      setNewAccesory({ ...accesory, barCode: codeBar });
    } else {
      setNewAccesory({ ...accesory, [name]: value });
      if (name === "providerId") {
        providerArray.forEach((element) => {
          if (element.id === value) {
            setTimeGuarantee(element.timeGuarantee);
          }
        });
      }
    }
  };

  const handleSubmitForm = async (event) => {
    event.preventDefault();
    if (accesory.providerId === undefined) {
      setHasError(true);
      return;
    }
    if (accesory.subcategoryTypeId === undefined) {
      setErrorSubcategory(true);
      return;
    }
    setNewAccesory({ ...accesory, inDistribution: 0 });
  };

  const handleCloseModal = (openModal) => setOpenModal(openModal);

  const handleColorSelect = (color) => setNewAccesory({ ...accesory, color });

  return (
    <React.Fragment>
      <ValidatorForm
        noValidate
        onKeyPress={(event) => {
          if (event.which === 13 /* Enter */) {
            event.preventDefault();
          }
        }}
        className={classes.form}
        method="POST"
        onSubmit={handleSubmitForm}
        onError={(errors) => {
          if (accesory.providerId === undefined) {
            setHasError(true);
          }
          if (accesory.subcategoryTypeId === undefined) {
            setErrorSubcategory(true);
          }
        }}
      >
        <Grid
          container
          direction="row"
          justify="flex-start"
          alignItems="center"
        >
          <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
            <Box className={classes.box}>
              <Typography
                variant="body2"
                component={"div"}
                className={classes.label}
              >
                Marca
              </Typography>
              <TextValidator
                name="brand"
                value={accesory.brand || ""}
                validators={["required"]}
                onChange={(e) => handleInputText(e)}
                errorMessages={["La marca es requerida"]}
                variant="outlined"
                inputProps={{
                  maxLength: 15,
                }}
              ></TextValidator>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
            <Box className={classes.box}>
              <Typography
                variant="body2"
                component={"div"}
                className={classes.label}
              >
                Modelo
              </Typography>
              <TextValidator
                name="model"
                value={accesory.model || ""}
                validators={["required"]}
                onChange={(e) => handleInputText(e)}
                errorMessages={["El modelo es requerido"]}
                variant="outlined"
                inputProps={{
                  maxLength: 15,
                }}
              ></TextValidator>
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
            <Box className={classes.box}>
              <SubcategorySelect
                errorSubcategory={errorSubcategory}
                formOption
                subcategory={handleSubcategorySelected}
              />
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
            <Button
              variant="contained"
              className={classes.addColorButton}
              style={{ marginBottom: -58 }}
              color="primary"
              onClick={() => setOpenModal(true)}
            >
              Agregar color
            </Button>
            <Box className={classes.box}>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel
                  shrink
                  id="demo-simple-select-placeholder-label-label"
                >
                  Color del accesorio
                </InputLabel>
                <ColorOptionForm
                  colorSelected={handleColorSelect}
                ></ColorOptionForm>
              </FormControl>
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
            <Box>
              <FormControl
                variant="outlined"
                className={classes.formControl}
                error={hasError}
              >
                <Typography
                  variant="body2"
                  component={"div"}
                  className={classes.label}
                >
                  Proveedor
                </Typography>

                <Select
                  disabled={false}
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  name="providerId"
                  required
                  value={accesory.providerId || ""}
                  onChange={(e) => handleInputText(e)}
                >
                  {providerArray.map((product, id) => {
                    return (
                      <MenuItem key={id} value={product.id || ""}>
                        {product.name}
                      </MenuItem>
                    );
                  })}
                </Select>
                {hasError && (
                  <FormHelperText>Seleccionar un proveedor</FormHelperText>
                )}
              </FormControl>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
            <FormControl variant="outlined" className={classes.formControl}>
              <Typography
                variant="body2"
                component={"div"}
                className={classes.label}
              >
                Garantía
              </Typography>

              <TextValidator
                InputProps={{
                  readOnly: true,
                }}
                value={timeGuarantee || ""}
                variant="outlined"
                inputProps={{
                  maxLength: 4,
                }}
              ></TextValidator>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
            <Box className={classes.box}>
              <Typography
                variant="body2"
                component={"div"}
                className={classes.label}
              >
                Costo
              </Typography>
              <TextField
                name="cost"
                value={accesory.cost || ""}
                onChange={(e) => handleInputText(e)}
                variant="outlined"
                InputProps={{
                  inputComponent: NumberFormatCustom,
                }}
              ></TextField>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
            <Box className={classes.box}>
              <Typography
                variant="body2"
                component={"div"}
                className={classes.label}
              >
                Precio
              </Typography>

              <TextField
                name="price"
                value={accesory.price || ""}
                onChange={(e) => handleInputText(e)}
                variant="outlined"
                InputProps={{
                  inputComponent: NumberFormatCustom,
                }}
              ></TextField>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
            <Box className={classes.box}>
              <Typography
                variant="body2"
                component={"div"}
                className={classes.label}
              >
                Descuento
              </Typography>
              <TextField
                name="discount"
                value={accesory.discount || ""}
                onChange={(e) => handleInputText(e)}
                variant="outlined"
                placeholder="Ingresar monto o dejar en blanco"
                InputProps={{
                  inputComponent: NumberFormatCustom,
                }}
              ></TextField>
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
            <Box className={classes.box}>
              <Typography
                variant="body2"
                component={"div"}
                className={classes.label}
              >
                Código de barras
              </Typography>
              <InputMask
                mask="9999-9999-9999-9999-9999"
                maskChar=""
                value={accesory.barCode || ""}
                onChange={(e) => handleInputText(e)}
              >
                {() => (
                  <TextValidator
                    name="barCode"
                    validators={["required"]}
                    errorMessages={["El código de barras es requerido"]}
                    variant="outlined"
                    inputProps={{
                      maxLength: 30,
                    }}
                  ></TextValidator>
                )}
              </InputMask>
            </Box>
          </Grid>

          <Grid container direction="row" justify="center" alignItems="center">
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                disabled={disabledButton}
                className={classes.rightButton}
                type="submit"
                style={{ marginTop: "40px", fontSize: 14, width: 150 }}
                endIcon={
                  <ArrowRightAltIcon
                    className={classes.backgroundIcon}
                    color="primary"
                  ></ArrowRightAltIcon>
                }
              >
                Inventario
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </ValidatorForm>

      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        fullScreen={fullScreen}
        open={openModal}
        onClose={() => setOpenModal(false)}
        aria-labelledby="form-dialog-title"
      >
        <DialogContent style={{ overflow: "hidden" }}>
          <ModalAddColor openModal={handleCloseModal}></ModalAddColor>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
};
export default connect(null, dispatch)(AccesoryForm);
